import { Component, OnInit,ViewChild } from '@angular/core';
import { VehicleRegisterService } from 'app/shared/services/vehicle-register.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DialogService } from 'app/shared/services/dialog.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NbThemeService } from '@nebular/theme';
import { AuthService } from 'app/shared/services/auth.service';

@Component({
  selector: 'ngx-vehicle-register-list',
  templateUrl: './vehicle-register-list.component.html',
  styleUrls: ['./vehicle-register-list.component.scss']
})
export class VehicleRegisterListComponent implements OnInit {

  displayedColumns: string[] = ['VehicleId', 'VehicleNo', 'Brand', 'Model','Color','CreatedBy','Action'];
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dataSource :MatTableDataSource<any>
  searchKey : string;
  isDark: boolean = false;

  vehicleList : any[];

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };
  
  statusCode: number;

  constructor(private vehicleRegisterService : VehicleRegisterService,
              private dialogService : DialogService,
              private router : Router, 
              private toastr: ToastrService,
              private route: ActivatedRoute,
              private themeService: NbThemeService,
              private authService: AuthService,
              ) { }

  ngOnInit() {
    this.getAll();
    this.getControlPermissions();

    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });
  }

  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='VH'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }

  newButtonClick(){
   this.vehicleRegisterService.dataRow = null;
   this.router.navigate(['../vehicle-register'],{relativeTo : this.route});
   

  }
  
getAll(){
    this.vehicleRegisterService.getAll()
     .subscribe(
        (data) => {
                  this.vehicleList = data;
                  this.dataSource = new  MatTableDataSource (this.vehicleList );  
                  this.dataSource.sort = this.sort;
                  this.dataSource.paginator = this.paginator;  
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                 });  
       
     }

     getRowData(row){   
      this.vehicleRegisterService.dataRow = row;  
      this.router.navigate(['../vehicle-register'],{relativeTo : this.route});
   }
        
   
   deleteButtonClick(itemCode : string){
          this.dialogService.openConfirmDialog('Are you sure you want to delete this record?')
          .afterClosed().subscribe(res =>{
            if(res){
              this.vehicleRegisterService.deleteVehicleRegister(itemCode)
            .subscribe(
              (res) => {
                          this.toastr.success('Deleted successfully','Success');
                          this.getAll();
                          console.log(res);     
                        },        
              (err) =>  {
                          this.toastr.error('Failed to delete record','Failure');
                          if(err instanceof HttpErrorResponse){                 
                            if(err.status == 401){
                              this.router.navigate(['/login']);
                            }
                          }
                          console.log(err);
                        }, 
                )
            }
          });            
      }

      applyFilter(){
        this.dataSource.filter =this.searchKey.trim().toLowerCase();

      }
      onSearchClear(){
        this.searchKey = "";
        this.applyFilter();
      }



   

}